export default "__VITE_ASSET__DEAbfEDL__"